import { Node, mergeAttributes } from "@tiptap/react";

export interface VariavelNodeOptions {
  rotulos: Record<string, string>;
}

declare module "@tiptap/react" {
  interface Commands<ReturnType> {
    variavel: {
      inserirVariavel: (nome: string) => ReturnType;
    };
  }
}

/**
 * Campo do documento (nome da agência, código, percentual...). No HTML salvo é
 * `<span data-variavel="NOME"></span>` vazio; o servidor troca pelo valor. No
 * editor aparece como um chip que não se edita por dentro.
 */
export const VariavelNode = Node.create<VariavelNodeOptions>({
  name: "variavel",
  group: "inline",
  inline: true,
  atom: true,
  selectable: true,

  addOptions() {
    return { rotulos: {} };
  },

  addAttributes() {
    return {
      nome: {
        default: null,
        parseHTML: (elemento) => elemento.getAttribute("data-variavel"),
        renderHTML: (atributos) => ({ "data-variavel": atributos.nome }),
      },
    };
  },

  parseHTML() {
    return [{ tag: "span[data-variavel]" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(HTMLAttributes)];
  },

  renderText({ node }) {
    return `[${this.options.rotulos[node.attrs.nome] ?? node.attrs.nome}]`;
  },

  addNodeView() {
    return ({ node }) => {
      const chip = document.createElement("span");
      chip.contentEditable = "false";
      chip.setAttribute("data-variavel", node.attrs.nome ?? "");
      chip.className =
        "mx-0.5 inline-flex items-center rounded-md border border-sky-200 bg-sky-50 px-1.5 py-px align-baseline text-[0.85em] font-medium text-sky-800";
      chip.textContent = this.options.rotulos[node.attrs.nome] ?? node.attrs.nome ?? "campo";
      return { dom: chip };
    };
  },

  addCommands() {
    return {
      inserirVariavel:
        (nome: string) =>
        ({ commands }) =>
          commands.insertContent({ type: this.name, attrs: { nome } }),
    };
  },
});
